import { render, staticRenderFns } from "./Decisao.vue?vue&type=template&id=00458a2a&scoped=true"
import script from "./Decisao.vue?vue&type=script&lang=js"
export * from "./Decisao.vue?vue&type=script&lang=js"
import style0 from "./Decisao.vue?vue&type=style&index=0&id=00458a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00458a2a",
  null
  
)

export default component.exports